<script>
  import tiposAceitos from '~js/tipos-arquivos-upload';
  
  export default {
    data() {
      return {
        arquivo: null,
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      nomeArquivo() {
        return this.arquivo ? this.arquivo.name : ''; 
      }
    },
    methods: {
      eventSelecionarArquivo() {
        this.$refs.input.click();
      },
      processarArquivo(evento) {
        this.arquivo = evento.target.files[0];

        if (!this.validarArquivo()) {
          toastr.warning('O envio desse tipo de arquivo não é permitido.');
          this.removerArquivo();
        }
        if (this.configuracao.limiteArquivoWeb > 0 && this.arquivo.size > this.configuracao.limiteArquivoWeb) {
          toastr.warning(`O arquivo não pode ser maior que ${(this.configuracao.limiteArquivoWeb / 1024 / 1024).toFixed(2)} megabytes.`);
          this.removerArquivo();
        }
        
        this.$emit('input', this.arquivo);
      },
      removerArquivo() {
        this.$refs.input.value = null;
        
        this.arquivo = null;
        
        this.$emit('input', this.arquivo);
      },
      validarArquivo() {        
        for(let i = 0; i < tiposAceitos.length; i++) {
          if(this.arquivo.type === tiposAceitos[i]) {
            return true;
          }
        }

        return false;
      }
    }
  }
</script>

<template>
  <div>
    <div class="fileinput input-group">
      <div class="form-control" @click="eventSelecionarArquivo">
        <i class="fa fa-file" v-show="nomeArquivo !== ''"></i>
        <span class="fileinput-filename">{{ nomeArquivo }}</span>
      </div>
      <span class="input-group-addon btn btn-default btn-file">
        <span>
          <i class="fa fa-folder-open-o"></i>
          Selecionar arquivo
        </span>
        <input type="file" ref="input" @change="processarArquivo" accept="image/*,.xml,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet" />
      </span>
      <a href="" @click.prevent="removerArquivo" class="input-group-addon btn btn-default" v-show="nomeArquivo !== ''">
        <i class="fa fa-trash"></i>
        Remover
      </a>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/InputFile.vue